import { KText } from '@/ui-library/components/text';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
  Icon,
  useDisclosure,
  useOutsideClick,
  Flex,
} from '@chakra-ui/react';
import { CheckIcon } from '@heroicons/react/solid';
import { ChevronDown } from '@kula-ai/icons/outline/ChevronDown';
import { useEffect, useRef, useState } from 'react';

export const SortByFilter = ({
  sort = {},
  filterActions = () => {},
  options = [],
  menuItemStyles = {},
}) => {
  const ref = useRef();
  const { isOpen, onClose, onToggle } = useDisclosure();
  const [selectedSort, setSelectedSort] = useState(() => {
    return Object.keys(sort).length > 0
      ? sort
      : options.length > 0
      ? options[0]
      : {};
  });

  useEffect(() => {
    setSelectedSort(sort);
  }, [sort]);

  const handleSortBy = (option = {}) => {
    filterActions({ type: 'sort', option });
    setSelectedSort(option);
    onClose();
  };

  useOutsideClick({
    ref: ref,
    handler: () => onClose(),
  });

  const renderHeader = () => {
    return (
      <MenuButton onClick={onToggle}>
        <Flex gap=".25em" alignItems="center">
          <KText size="sm-semi-bold" color="secondary-800">
            Sort by:
          </KText>
          <KText onClick={onToggle}>{selectedSort?.label}</KText>
          <Icon
            as={ChevronDown}
            height="16px"
            width="16px"
            color="secondary-900"
          />
        </Flex>
      </MenuButton>
    );
  };

  const renderOption = (option = {}) => {
    const { element, order } = option;
    const isOptionSelected =
      selectedSort.element === element && selectedSort.order === order;
    return (
      <MenuItem
        key={element + order}
        onClick={() => handleSortBy(option)}
        minW="220px"
        _hover={{ background: 'secondary-50' }}
        {...menuItemStyles}
      >
        <Box flex="1">
          <Flex
            gap="3px"
            w="inherit"
            alignItems="center"
            justifyContent="space-between"
          >
            <KText
              color={isOptionSelected ? 'primary-500' : 'secondary-700'}
              size={isOptionSelected ? 'sm-medium' : 'sm'}
            >
              {option.label}
            </KText>
            {isOptionSelected && (
              <Icon
                as={CheckIcon}
                color="ats-primary"
                width="20px"
                height="20px"
              />
            )}
          </Flex>
        </Box>
      </MenuItem>
    );
  };

  return (
    <Flex alignItems="center" ref={ref}>
      <Menu placement="bottom-end" isOpen={isOpen}>
        {renderHeader()}
        <MenuList zIndex="3">{options.map(renderOption)}</MenuList>
      </Menu>
    </Flex>
  );
};
